import { Box, FormLabel, styled } from "@mui/material";

export const Container = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const Row = styled(Box, {
  shouldForwardProp: (prop) => prop !== "selected",
})<{ selected?: boolean }>(({ theme, selected }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  cursor: "pointer",
  paddingRight: theme.spacing(0.5),
  borderRadius: theme.spacing(0.5),
  backgroundColor: selected ? theme.palette.action.selected : "transparent",
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const Label = styled(FormLabel, {
  shouldForwardProp: (prop) => prop !== "editing",
})<{ editing?: boolean }>(({ theme, editing }) => ({
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  gap: 0,
  margin: 0,
  minWidth: 0,
  whiteSpace: "nowrap",
  fontSize: theme.typography.caption.fontSize,
  fontWeight: editing ? 600 : 400,
  "& > span": {
    flex: 1,
    minWidth: 0,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}));
